export const environment = {
  production: false,
  baseUrl: 'https://dev.api.amigofarma.pe'
};
